import type { PerioToothData } from '@/modules/claims/freeClaims/insuranceExport/types';

import type { Position, Side } from './types';

export const BleedingDots = ({
  tooth,
  side,
}: {
  tooth: PerioToothData;
  side: Side;
}) => {
  const positions: Position[] = ['distal', 'center', 'mesial'];
  return (
    <div className="vai-flex vai-justify-center vai-gap-1">
      {positions.map((pos) => (
        <div key={pos} className="vai-w-2 vai-h-2">
          {/* In the perio chart, 1 is used to indicate that the tooth is bleeding */}
          {tooth[side][pos].bleeding === '1' && (
            <div className="vai-w-2 vai-h-2 vai-bg-red-600 vai-rounded-full"></div>
          )}
        </div>
      ))}
    </div>
  );
};
